export const default_borrower = {
  first_name: "",
  middle_name: "",
  last_name: "",
  suffix: "",
  current_address: "",
  current_address_2: "",
  city: "",
  state: "",
  zip_code: "",
  currently_renting_or_owning: "",
  market_value: "0",
  // Current residence disposition + occupancy (shown on Applicant Info when the
  // borrower OWNS). Same options as an REO property — a move-up buyer keeps
  // their primary as an investment. See constants/property_disposition.
  residence_disposition_status: "",
  residence_intended_occupancy: "",
  residence_current_occupancy: "",
  rental_amount: "0",
  how_long_in_current_residence: "0",
  years_at_current_residence: "0",
  marital_status: "",
  married_to: "",
  email: "",
  cell_phone: "",
  home_phone: "",
  work_phone: "",
  ssn: "",
  date_of_birth: "",
  is_veteran: "",
  on_title: "",
  on_title_note: "",
  on_loan: "",
  on_loan_note: "",
  lowest_credit_mid_score: "",
  // Individual bureau scores from a credit pull / MISMO 3.4 import. Blank until
  // a credit report is imported. credit_mid_score is the borrower's
  // representative (middle) score, computed from the three above at import time.
  // Pricing still keys off lowest_credit_mid_score (the range bucket), which is
  // auto-derived from credit_mid_score on import.
  credit_score_experian: "",
  credit_score_transunion: "",
  credit_score_equifax: "",
  credit_mid_score: "",
  same_address_as: "",
  income: {
    sources: [],
    other_income: []
  },
  reserves: []
};
